import {hasPermission} from 'services/utils/permissionHelpers'
import GridViewRoundedIcon from '@mui/icons-material/GridViewRounded'
import PeopleRoundedIcon from '@mui/icons-material/PeopleRounded'
import HomeRoundedIcon from '@mui/icons-material/HomeRounded'
import ElectricMeterRoundedIcon from '@mui/icons-material/ElectricMeterRounded'
import PointOfSaleRoundedIcon from '@mui/icons-material/PointOfSaleRounded'
import LocationCityRoundedIcon from '@mui/icons-material/LocationCityRounded'
import AccountBoxRoundedIcon from '@mui/icons-material/AccountBoxRounded'
// import InsertDriveFileRoundedIcon from '@mui/icons-material/InsertDriveFileRounded'
import ShoppingCartRoundedIcon from '@mui/icons-material/ShoppingCartRounded'
import LanRoundedIcon from '@mui/icons-material/LanRounded'
import WarningRoundedIcon from '@mui/icons-material/WarningRounded'
import PaidRoundedIcon from '@mui/icons-material/PaidRounded'
const menuPermissions = {
    dashboard: 'DASHBOARD',
    site: 'ACCOUNTS',
    users: 'USERS',
    consumers: 'CONSUMERS',
    meters: 'METERS',
    structures: 'STRUCTURES',
    rates: 'RATES',
    meterRadings: 'METERS_READING',
    invoices: 'INVOICES',
    faultLogs: 'FAULT_LOG',
    payments: 'PAYMENTS',
}

const permissionKeyToMenuItem = Object.entries(menuPermissions).reduce(
    (acc, [menuKey, permissionKey]) => {
        acc[permissionKey] = menuKey
        return acc
    },
    {}
)
const siteMenu = () => {
    return {
        dashboard: {text: 'dashboard', icon: <GridViewRoundedIcon />, navigate: '/dashboard'},
        site: {text: 'sites', icon: <HomeRoundedIcon />, navigate: '/sites', category: 'management'},
        users: {text: 'users', icon: <AccountBoxRoundedIcon />, navigate: '/users', category: 'management'},
        consumers: {text: 'consumers', icon: <PeopleRoundedIcon />, navigate: '/consumers', category: 'management'},
        meters: {text: 'meters', icon: <ElectricMeterRoundedIcon />, navigate: '/meters', category: 'management'},
        structures: {
            text: 'structures',
            icon: <LocationCityRoundedIcon />,
            navigate: '/structures',
            category: 'management',
        },
        meterRadings: {
            text: 'meter_readings',
            icon: <LanRoundedIcon />,
            navigate: '/meter_readings',
            category: 'management',
        },
        rates: {text: 'rates', icon: <PointOfSaleRoundedIcon />, navigate: '/rates', category: 'billing'},
        invoices: {text: 'invoices', icon: <ShoppingCartRoundedIcon />, navigate: '/invoices', category: 'billing'},
        payments: {text: 'payments', icon: <PaidRoundedIcon />, navigate: '/payments', category: 'billing'},
        faultLogs: {text: 'fault_logs', icon: <WarningRoundedIcon />, navigate: '/fault_logs', category: 'system'},
    }
}

export const getMenuSiteByRole = (user, account) => {
    const {isSuperUser} = user || {}
    const {permissions: accountPermissions} = account || {}
    const list = siteMenu()
    const allowedMenu = {}
    if (isSuperUser && !account) {
        return list
    } else if (isSuperUser && account) {
        delete list.site
        return list
    }

    const userWithAccount = {isSuperUser, account}
    if (accountPermissions) {
        Object.keys(accountPermissions).forEach((permissionKey) => {
            if (!hasPermission(userWithAccount, permissionKey, 'READ')) return

            const menuKey = permissionKeyToMenuItem[permissionKey]
            if (menuKey && list[menuKey]) {
                allowedMenu[menuKey] = list[menuKey]
            }
        })
    }
    if (account) {
        delete allowedMenu.site
    }
    return allowedMenu
}
